import { Card, Grid, pn, useElementBreakpoints, ValidationErrors } from "@compass/core";
import { DatePicker } from "components";
import { StudentReportNscDisplay } from "generated/openApi";
import produce from "immer";
import { Box, Typography } from "@compass/core";

export const NscDisplay = (props: {
  display: StudentReportNscDisplay;
  setDisplay: (filter: StudentReportNscDisplay) => void;
  validationErrors: ValidationErrors | string[];
}) => {
  const { breakpointsRef, smallFieldBreakpoints } = useElementBreakpoints();


    const today = new Date();
    let yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);


  const dateField = () => {
    const propertyName = pn<StudentReportNscDisplay>("searchBeginDate");

      return (
          <Box display="flex" alignItems="center" gap={1}>
              <DatePicker
                label="Search Begin Date"
                required
                errors={props.validationErrors[propertyName]}
                value={props.display.searchBeginDate}
                maxDate={yesterday}
                onChange={(value) => {
                  props.setDisplay(
                    produce(props.display, (draft) => {
                      draft.searchBeginDate = value;
                    })
                  );
                }}
              />
                <Typography variant="body2" color="textSecondary">
                    (Must be yesterday or earlier)
                 </Typography>
          </Box>
    );
  };

  return (
    <Card header={"Display Items"}>
      <Grid ref={breakpointsRef} container>
        <Grid item xs={smallFieldBreakpoints}>
          {dateField()}
        </Grid>
      </Grid>
    </Card>
  );
};
